import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
  List, ListItemButton, ListItemText, Typography, Button, CircularProgress, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';
import SearchForm from '../components/SearchForm';
import Pagination from '../components/Pagination';

const ClientModal = ({ isOpen, onClose, onSelectClient }) => {

  const {
    dataset: clients,
    loading,
    error,
    currentPage,
    totalPages,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
  } = useDataFetch('/client', {
    client_code: '',
    client_name: '',
    is_pending: false
  });

  const searchItems = getFields(searchFields, ['client_name']);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      {/* タイトル */}
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        顧客選択
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>

        {/* 検索フォーム */}
        <SearchForm
          searchQuery={searchQuery}
          searchFields={searchItems}
          handleSearchChange={handleSearchChange}
          handleSearchSubmit={handleSearchSubmit}
          handleClearSearch={handleClearSearch}
        />

        {/* 顧客リスト */}
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">
            {error}
          </Typography>
        ) : clients.length > 0 ? (
          <List sx={{ maxHeight: 400, overflow: 'auto' }}>
            {clients.map(client => (
              <ListItemButton
                key={client.client_id}
                onClick={() => onSelectClient(client)}
              >
                <ListItemText
                  primary={`${client.client_name} ${client.branch_name ?? ''}`}
                  secondary={client.client_phone}
                />
              </ListItemButton>
            ))}
          </List>
        ) : (
          <Typography>顧客データがありません。</Typography>
        )}

        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientModal;
